import { useEffect } from 'react'

export function useWebTitle(title: string) {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = title
    }
  }, [title])
}
